"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinkText = exports.StyledLink = exports.styledOKELinkCSS = exports.genColor = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
var mixins_1 = require("../../../themes/mixins");
var genColor = function (_a) {
    var color = _a.color, theme = _a.theme, invert = _a.invert, disabled = _a.disabled;
    return disabled
        ? themes_1.colors.grey40
        : color
            ? themes_1.colors[color]
            : themes_1.colors.black;
};
exports.genColor = genColor;
// Separated out this way so we can use it in LexicalTextEditor's StyledEditorWrapperLex
exports.styledOKELinkCSS = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  display: inline-flex;\n  gap: 0.7rem;\n  align-items: center;\n  max-width: 100%;\n  text-decoration: none;\n  position: relative;\n  color: ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: ", ";\n    height: ", ";\n    pointer-events: ", ";\n    ", ";\n    background-color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    &::after { width: ", "; }\n  }\n"], ["\n  cursor: ", ";\n  display: inline-flex;\n  gap: 0.7rem;\n  align-items: center;\n  max-width: 100%;\n  text-decoration: none;\n  position: relative;\n  color: ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: ", ";\n    height: ", ";\n    pointer-events: ", ";\n    ", ";\n    background-color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    &::after { width: ", "; }\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return !disabled ? 'pointer' : 'not-allowed';
}, exports.genColor, function (_a) {
    var invertUnderline = _a.invertUnderline;
    return invertUnderline ? 0 : '100%';
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled ? '1px' : 0;
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled ? 'unset' : 'none';
}, (0, mixins_1.transition)('width'), exports.genColor, exports.genColor, function (_a) {
    var invertUnderline = _a.invertUnderline;
    return invertUnderline ? '100%' : 0;
});
exports.StyledLink = styled_components_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.styledOKELinkCSS);
exports.StyledLinkText = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 100%;\n  ", ";\n"], ["\n  max-width: 100%;\n  ", ";\n"])), mixins_1.ellipsis);
var templateObject_1, templateObject_2, templateObject_3;
